import React from 'react'
import styled from 'styled-components'
import { Text, Box } from 'uikit'
import { useTranslation } from 'contexts/Localization'

const ModelBg = styled(Box)`
  ${({ theme }) => theme.mediaQueries.lg} {
    background-image: url('/images/home/scaling-bg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
`

const PurpleTitle = styled(Text)`
  font-size: 18px;

  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 20px;
  }
`

const Title = styled(Text)`
  font-size: 25px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 30px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 35px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 40px;
  }
`

const BottomText = styled(Text)`
  font-size: 20px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 25px;
  }
`

const Scaliing: React.FC = () => {
  const { t } = useTranslation()

  return (
    <ModelBg mt={['90px', null, '170px', null, '210px']} px={['32px', null, '57px']}>
      <PurpleTitle color="primary" fontWeight="600" textAlign="center">
        {t('Scaling Up')}
      </PurpleTitle>
      <Title fontWeight="600" textAlign="center">
        {t('Services for the People')}
      </Title>
      <Text
        fontSize="16px"
        fontWeight="300"
        textAlign="center"
        color="textSecondary"
        mx="auto"
        mt={['16px', null, null, null, '20px']}
        maxWidth="780px"
      >
        {t(
          'Dark Matter DeFi was created with the vision to bring value and use cases to the NFT space by merging yield farming, NFTs, and our storyline into one big ecosystem.',
        )}
      </Text>
      <BottomText fontSize="25px" color="primary" fontWeight="600" textAlign="center" mt="34px">
        NFT&nbsp;&nbsp;|&nbsp;&nbsp;Launchpad&nbsp;&nbsp;|&nbsp;&nbsp;Earn
      </BottomText>
    </ModelBg>
  )
}

export default Scaliing
